// Surfaces build-time info for debugging stale bundles.
export const BUILD_VERSION = (import.meta.env.VITE_BUILD_ID as string | undefined) ?? 'dev';
